const doc = [({"en":({"js":({"admin":({"contacts":({"edit":({"email":({"email_address":"Email address"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;